function ReferrerService($state, $cookies, Cause, Subscriber, bcrypt, ConfigEnvironment, $q) {
  "ngInject";

  let _currentUserInstance;

  const setCurrentUser = (currentUser) => _currentUserInstance = currentUser;

  let nonselectiveSponsors = ConfigEnvironment.getConfiguration("nonselective_sponsors");

  function getHashableStringFromCurrentState(state, params) {
    let hashableString = false;
    switch(state.current.name) {
      case "join.setup-referred-by.default":
        hashableString = params.entity_type + params.entity_id;
        break;
      case "join.setup-referred-by.subentity":
        hashableString = params.entity_type + params.entity_id + params.subentity_id;
        break;
      case "join.setup-referred-by.referrer":
        hashableString = params.entity_type + params.entity_id + params.referrer_id;
        break;
      case "join.setup-referred-by.subentity-referrer":
        hashableString = params.entity_type + params.entity_id + params.subentity_id + params.referrer_id;
        break;
      default:
        throw new Error("could not get hashable string for current state name: " + state.current.name);
    }
    return hashableString;
  }

  let isReferralHashValid = function(hash, fromString) {
    try {
      const hashedString = bcrypt.hashSync(fromString, 4);
      console.log(fromString, hashedString, hash);
      return bcrypt.compareSync(fromString, hash);
    } catch(err) {
      console.log(err.message);
      //bcrypt most likely not supported so we take what we can get
      return true;
    }
  }

  let processReferral = function(state, stateParams, callback) {
    console.log(state, stateParams);
    const fromString = getHashableStringFromCurrentState(state, stateParams);
    if(isReferralHashValid(stateParams.hash, fromString)) {
      const expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 14);
      $cookies.putObject('referredBy', stateParams);
      callback(undefined, true);
    }
    else {
      callback(new Error("Invalid Hash"));
    }
  }

  let hasReferrer = function() {
    return !!getReferredBy();
  }

  let hasReferrerAndEntityId = function() {
    return (this.hasReferrer() && this.getReferredBy().entity_id);
  }

  let getReferredBy = function() {
    let referredBy = $cookies.getObject('referredBy');
    if (!referredBy && _currentUserInstance) {
      referredBy = _currentUserInstance.referred_by;
    }
    //https://github.com/Startup-Media/greenback-api/issues/146
    if (referredBy && !referredBy.entity_id && referredBy.gb_cause_id) {
      referredBy.entity_id = referredBy.gb_cause_id;
    }
    return referredBy;
  }

  let isNonselectiveReferrer = function() {
    let referredBy = getReferredBy();
    return nonselectiveSponsors.indexOf(parseInt(referredBy.entity_id)) !== -1;
  }

  function getActiveCausesJoinableFromGeneric() {
    return Cause.find({
      "filter": {
        "where": {
          "and": [
            {"is_joinable_from_generic": true},
            {"is_active": true},
            {"is_sponsor": false}
          ]
        },
        "order": "priority ASC"
      }
    }).$promise;
  }

  function getSponsoredCauses(sponsorsPromise) {

    let result;

    if(isNonselectiveReferrer()) {
      return getActiveCausesJoinableFromGeneric();
    }
    else {
      let defer = $q.defer();
      sponsorsPromise.then(function(sponsors) {

        let sponsor = sponsors[0];

        if (!sponsor || !sponsor.sponsors_of || !sponsor.sponsors_of.length) defer.resolve(getActiveCausesJoinableFromGeneric());

        let filter = {
          "where": {
            "and": [
              {"id": {"inq": sponsor.sponsors_of}},
              {"is_active": true},
              {"is_sponsor": false}
            ]
          }
        };
        result = Cause.find({"filter": filter});
        defer.resolve(result.$promise);
      }).catch(function(err) {
        defer.reject(err);
        console.error(err);
      });

      return defer.promise;
    }
  }

  let getCausesForReferral = function(callback) {

    let referredBy = getReferredBy();

    if(!referredBy.entity_id) {
      throw new Error("entity_id is required.");
    }

    let result = Cause.find({
      "filter": {
        "where": {
          "and": [
            {"id": referredBy.entity_id},
            {"is_active": true}
          ]
        }
      }
    });
    if(referredBy.entity_type === "sponsor") {
      return getSponsoredCauses(result.$promise);
    }
    else {
      let defer = $q.defer();
      result.$promise.then((causes) => {
        if (causes && causes.length) {
          defer.resolve(causes);
        }
        else {
          defer.resolve(getActiveCausesJoinableFromGeneric());
        }
      });
      return defer.promise;
    }
  }

  return {
    setCurrentUser: setCurrentUser,
    processReferral: processReferral,
    hasReferrer: hasReferrer,
    hasReferrerAndEntityId: hasReferrerAndEntityId,
    getReferredBy: getReferredBy,
    isNonselectiveReferrer: isNonselectiveReferrer,
    getCausesForReferral: getCausesForReferral,
    getActiveCausesJoinableFromGeneric: getActiveCausesJoinableFromGeneric
  }
}

export default ReferrerService;



// WEBPACK FOOTER //
// ./js/containers/users/services/referrer.service.js